import type { StyleRule } from '@vanilla-extract/css';

import Borders from '@dynatrace/strato-design-tokens/borders';
import Colors from '@dynatrace/strato-design-tokens/colors';
import Easings from '@dynatrace/strato-design-tokens/easings';
import Spacings from '@dynatrace/strato-design-tokens/spacings';
import Timings from '@dynatrace/strato-design-tokens/timings';

import { vrResizeSeparatorOverrides } from '../visual-refresh-overrides.js';

/**
 * @internal
 */
export const resizeSeparatorStyles = {
  backgroundColor: Colors.Border.Neutral.Accent,
  border: 'none',
  borderRadius: Borders.Radius.Field.Default,
  cursor: 'col-resize',
  height: Spacings.Size36,
  left: '3px',
  margin: 0,
  padding: 0,
  touchAction: 'none',
  transition: `height ${Timings.Base.Default} ${Easings.FastInSlowOut}`,
  width: '2px',
  selectors: {
    '&:focus-visible': {
      width: '100%',
    },
    // If we click the handle we don't want to apply the extra handling for the boxShadow
    '&:hover&:focus-visible': {
      width: '2px',
    },
    '&:focus-visible, &:hover': {
      height: Spacings.Size48,
      backgroundColor: Colors.Border.Neutral.AccentHover,
    },
    // The resizing ref is applied to the actual handle to manage the focus state by the ref.
    // However, this would make only the handle resizable and not the whole separator, hence the after element.
    '&:after': {
      content: '""',
      display: 'block',
      height: '100%',
      left: '50%',
      position: 'absolute',
      top: 0,
      transform: 'translateX(-50%)',
      userSelect: 'none',
      width: '100%',
    },
    ...vrResizeSeparatorOverrides,
  },
} satisfies StyleRule;
